module.exports = __webpack_public_path__ + "media/components/assets/bottle_03-a94179a2cc87dd326392c11717ffe1c7.png";